import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid, Typography, FormControlLabel, Checkbox } from '@mui/material'
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';

// COMPONENTES
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';

const EditarConfig = ({ open, onClose, refresh, users, data }) => {

    return (

        <Dialog
            open={open}
            onClose={onClose}
        >

            {/* HEADER */}

            <DialogTitle sx={{ textAlign: 'center' }}>
                Configuracion
            </DialogTitle>

            {/* BODY */}

            <DialogContent sx={{ width: 300 }}>

                <Formik
                    initialValues={data}
                    enableReinitialize={true}
                    validationSchema={Yup.object({
                        id_user: Yup.string().required('Selecciona un usuario'),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => { console.log(values)

                        try {

                            const response = await myApi.put('/idle/config/update', values);

                            console.log(response)

                            if(response.data){

                                setSubmitting(false);
                                resetForm();
                                onClose();
                                refresh();

                                Swal.fire({
                                    icon: 'success',
                                    title: 'Configuracion Finalizada',
                                });

                            }

                        } catch(e) {

                            console.log(e);
                            setSubmitting(false);
                            resetForm();

                        }   

                    }}
                >
                {({ handleSubmit }) => (

                    <Form>

                        <Grid container spacing={2} marginTop={1}>

                            {/* USUARIO */}

                            <Grid size={12}>

                                <MyAutoComplete
                                    name="id_user"
                                    label="Usuario"
                                    options={users}
                                />

                            </Grid>

                            <Grid size={12}>
       
                                <Grid container spacing={2}>
                                    {/* Columna 1: Fleet */}
                                    <Grid size={6}>
                                        <Typography variant="subtitle2">Fleet</Typography>
                                        {['FLEET1', 'FLEET2', 'FLEET3', 'FLEET4', 'XFER'].map((key) => (
                                            <Field name={`json_config.${key}`} key={key}>
                                                {({ field, form }) => (
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                checked={!!form.values.json_config[key]}
                                                                onChange={(e) =>
                                                                    form.setFieldValue(`json_config.${key}`, e.target.checked ? 1 : 0)
                                                                }
                                                            />
                                                        }
                                                        label={key}
                                                    />
                                                )}
                                            </Field>
                                        ))}
                                    </Grid>

                                    {/* Columna 2: Type Of */}
                                    <Grid size={6}>
                                        <Typography variant="subtitle2">Vehicle Type</Typography>
                                        {['USA', 'BPMX'].map((key) => (
                                            <Field name={`json_config.${key}`} key={key}>
                                                {({ field, form }) => (
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                {...field}
                                                                checked={!!form.values.json_config[key]}
                                                                onChange={(e) =>
                                                                    form.setFieldValue(`json_config.${key}`, e.target.checked ? 1 : 0)
                                                                }
                                                            />
                                                        }
                                                        label={key}
                                                    />
                                                )}
                                            </Field>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>


                            {/* FOOTER */}

                            <Grid size={12}>

                                <DialogActions
                                    sx={{ justifyContent: 'space-between' }}
                                >

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Guardar
                                    </Button>

                                    <Button onClick={onClose}>Cancelar</Button>

                                </DialogActions>

                            </Grid>

                        </Grid>

                    </Form>

                )}
                </Formik>

            </DialogContent>

        </Dialog>

    )

}

export default EditarConfig